<template>
    <transition name="dropdown-content">

        <div v-if="active" class="absolute right-0 z-10 mt-2 w-40 origin-top-right border border-gray-300/50 dark:border-neutral-600/50 rounded bg-white dark:bg-neutral-800 shadow-2xl focus:outline-none"
            role="menu" aria-orientation="vertical">
            <div class="py-1" role="none">
                <slot />
            </div>
        </div>

    </transition>
</template>
  
<script>
export default {
    name: "AppDropdownContent",
    inject: ["sharedState"],
    computed: {
        active() {
            return this.sharedState.active;
        }
    }
};
</script>
  
<style>
.dropdown-content-enter-active,
.dropdown-content-leave-active {
    transition: all 0.1s;
}

.dropdown-content-enter,
.dropdown-content-leave-to {
    opacity: 0;
    transform: translateY(-5px) scale(0.9);
}
</style>
  